import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const VoucherImage = styled.img`
  margin-bottom: 16px;
  max-width: 180px;
`;

export const Title = styled.h3`
  ${({ theme }) => theme.kallisto.mixins.font('Title3')};
  margin-bottom: 16px;
`;

export const Description = styled.p`
  ${({ theme }) => theme.kallisto.mixins.font('Body')};
  margin-bottom: 16px;
`;

export const CodeContainer = styled.p`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;
  text-align: left;
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  strong {
    ${({ theme }) => theme.kallisto.mixins.font('Title6')};
  }

  img {
    margin-left: auto;
  }
`;

export const CodeText = styled.span``;
export const CodeIcon = styled.img`
  animation: fadeIn 0.5s ease-in-out;
`;
export const Terms = styled.a`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  margin: 0;
  text-decoration: underline;
  cursor: pointer;
`;

export const CopiedText = styled.span`
  display: flex;
  align-items: center;
  animation: fadeIn 0.5s ease-in-out;

  img {
    margin-right: 4px;
  }
`;
